import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabBenefitsComponent } from './tab-benefits.component';
import { MAIN_TABBENEFITS } from './tab-benefits.routes';
import { MatTableModule } from '@angular/material/table';
import { PaginatorSelectModule } from 'src/app/components/paginatorselect/paginatorselect.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [TabBenefitsComponent],
  imports: [
    CommonModule,
    MAIN_TABBENEFITS,
    MatTableModule,
    MatChipsModule,
    PaginatorSelectModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
  ],
  exports: [TabBenefitsComponent],
})
export class TabBenefitsModule {}
